
import { defineComponent } from "vue";
import { useStore } from "@/store";
import { MutationTypes as PlayerMutationTypes } from "@/store/player/mutation-types.ts";
import { MutationTypes as SysMutationTypes } from "@/store/sys/mutation-types.ts";
import router from "@/router";
import { confirm } from "@/util/confirm";

const ExitConfirm = defineComponent({
  name: "ExitConfirm",
  setup() {
    const handleClick = async () => {
      const res = await confirm("退出后您的金币将清零，是否退出游戏？");
      if (res) {
        const store = useStore();
        // 清理
        store.commit(PlayerMutationTypes.CLEAR_USER_INFO);
        store.commit(SysMutationTypes.SET_SYS_INFO, []);
        router.replace("/login");
      }
    };
    return {
      handleClick
    };
  }
});
export default ExitConfirm;
